import React, {useState, useEffect} from 'react'

import { ValidationForm } from 'react-bootstrap4-form-validation';
import { Button } from 'reactstrap';
import { Modal, ModalDialog } from 'react-bootstrap';
import ShowMessages from '../../components/Exceptions'
import Draggable from 'react-draggable';
import loadingButton  from '../layouts/Buttons'
import { SketchPicker } from 'react-color';
import api from '../../services/api';
import setStatistic from '../../services/apiStatistic'
import { TagsInput } from "react-tag-input-component";
import Loading from '../../components/Loading';
import Dropzone from "./../../components/dropzone";
import { convertToBase64 } from "./../../components/Utils";
import { LocalConvenienceStoreOutlined } from '@mui/icons-material';

class DraggableModalDialog extends React.Component {
	render() {
		return <Draggable handle=".modal-header"><ModalDialog {...this.props} /></Draggable>
	}
}

export default function ModalMyNumberSettings({showModal, handleCloseModal, data, handleReload}) {
    const [rejectcall, setRejectCall]                 = useState(false)
    const [messagereject,setMessageReject]            = useState('')
    const [loading, setLoading]                       = useState(false)
    const [numbercolor, setNumberColor]               = useState('')
    const [tags, setTags]                             = useState([]);
    const [saveLeadAttendance, setSaveLeadAttendance] = useState(false)
    const [dataTags, setDataTags]                     = useState([])
    const [tag, setTag]                               = useState('')
    const [selectedFile, setSelectedFile]             = useState(null)

    const addValidationTag = (_tag) => {
        if (_tag.trim() === '')
            return false
        _tag = _tag.toString().toUpperCase()
        return !tags.includes(_tag)
    }

    const handleColor = (color,event) => {
        if (color !== undefined)
            setNumberColor(color?.hex || '')
    }

    const setData = async(obj,clear) => {
        setLoading(true)
        await api.get('/getTags')
                 .then(response => {
                    setRejectCall(clear ? false : obj.rejectcall) 
                    setMessageReject(clear ? '' : obj.messagereject)
                    setNumberColor(clear ? '' : obj?.numbercolor || '')
                    setSaveLeadAttendance(obj?.saveleadattendance || false)
                    setTags(clear ? [] : (Object.keys(obj?.tags || {}).length === 0) ? [] : Array.isArray(obj.tags[0]) ? obj.tags[0] : obj.tags || []);
                    setDataTags(response.data)
                    setLoading(false)
                 })
                 .catch(e => {
                    console.log(e)
                 })
    }

    const handleTagInput = (value) => { 
        value = (value || []).map(function(x){ return x.toString().toUpperCase().replace(/[^a-zA-Z0-9_]/g,''); })     
        if (value === '')
            return false

        if (tags?.length !== value.length)
            setTags(value)
    }

    const handleSubmit = async(event) => {
        loadingButton(true,document.querySelector('#submit-mynumber-settings'),document.querySelector('#submit-mynumber-settings').children[0].classList,document.querySelector('#submit-mynumber-settings').lastChild.nodeValue)
        event.preventDefault()

        try {
            let _data = {rejectcall,
                         messagereject,
                         saveLeadAttendance,
                         tags,
                         numbercolor}

            await api.put('/mynumbers/' + data.idnumber, _data)
                     .then(response => {
                        ShowMessages(response)
                        if (response.ok) {
                            if (response.data.status === 200) {
                                handleCloseModal()  
                                handleReload(true)    
                            } else 
                                loadingButton(false,document.querySelector('#submit-mynumber-settings'))
                        } else 
                            loadingButton(false,document.querySelector('#submit-mynumber-settings'))
                    })
                    .catch( error => {
                        loadingButton(false,document.querySelector('#submit-mynumber-settings'))
                        ShowMessages(error) 
                    })

        } catch (response) {
            loadingButton(false,document.querySelector('#submit-mynumber-settings'))
            ShowMessages(response)
        }
    }

    const handleFiles = async (arrSelected) => {
        if (arrSelected.length === 0) return;
    
        const file = arrSelected[0]; // Apenas o primeiro arquivo selecionado
    
        if (file.size > 20971520) { // 20MB = 20 * 1024 * 1024 bytes
            ShowMessages({ status: 500, message: "O arquivo informado não pode ser maior que 20MB" });
            return;
        }
    
        const newFile = {
            src: URL.createObjectURL(file),
            altText: `${URL.createObjectURL(file)}`,
            file: URL.createObjectURL(file),
            name: file.name,
            size: file.size,
            type: file.type,
            base64: await convertToBase64(file)
        };
    
        setSelectedFile(newFile); 
    };

    const handleUploadFoto = async(e) => {
        if (!selectedFile) {
            ShowMessages({status : 500, message : "A foto não foi informada"})
            return
        }

        const _data = {
            number         : data.number,
            environment    : data.environment,
            token          : data.password,
            mimetype       : selectedFile.type,
            photo          : selectedFile.base64.replace(/^data:[^;]+;base64,/, ""),
            connectionType : data.connectiontype
        }

        await api.post('/api/v1/setProfilePicture', _data)
                 .then(response => {
                    ShowMessages(response)
                    if (response.ok) {
                        if (response.data.status === 200) {
                            handleCloseModal()  
                            handleReload(true)    
                        } else 
                            loadingButton(false,document.querySelector('#submit-mynumber-settings'))
                    } else 
                        loadingButton(false,document.querySelector('#submit-mynumber-settings'))
                })
                .catch( error => {
                    loadingButton(false,document.querySelector('#submit-mynumber-settings'))
                    ShowMessages(error) 
                })
    }

    useEffect(() => {
        setData(data,false)
    },[data,showModal])
   
    useEffect(() => {
        setStatistic('modals\\modal-mynumber-settings')
    } ,[])

    return (
        <Modal size='xl' show={showModal} onHide={handleCloseModal} animation={true} backdrop="static"  dialogAs={DraggableModalDialog}>
            <ValidationForm  onSubmit={handleSubmit} setFocusOnError={true} className="modal-content"> 
                <Modal.Header closeButton>
                    <Modal.Title style={{marginBottom:"0px"}}>
                        <i className="fa fa-cogs"></i> Configurações
                    </Modal.Title>
                </Modal.Header>
            
                <Modal.Body>
                    <div className='box-shadow' style={{padding:"10px", display:"flex", gap:"5px", flexDirection:"column", width:"600px"}}>
                        {loading ? <Loading loading={loading} addClass="heigth330px" /> :
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <div style={{ border: "1px solid #dee2e6", padding: "5px", borderRadius: "5px" }}>
                                    <div style={{ marginTop: "-15px", marginLeft: "10px" }}>
                                        <span style={{ fontWeight: "bold", background: "#fff" }}>Opções do Atendimento</span>
                                    </div>
                                    <div>
                                        <div style={{ display: "flex" }}>
                                            <label className="switch switch-sm" style={{ justifyContent: "center" }}>
                                                <input type="checkbox" checked={saveLeadAttendance}
                                                    value={saveLeadAttendance}
                                                    onClick={e => setSaveLeadAttendance(!saveLeadAttendance)} />
                                                <span style={{ marginTop: "5px" }}></span>
                                            </label>
                                            <div style={{ marginLeft: "5px", marginTop: "2px" }}>
                                                <span>Quando receber uma mensagem, salvar o lead?</span>
                                            </div>
                                        </div>
                                        {saveLeadAttendance && (
                                            <div style={{ display: "flex", gap: "15px", marginTop: "10px" }}>
                                                <div style={{ width: "400px" }}>
                                                    <label>Tags</label>
                                                    <div className="input-group">
                                                        <TagsInput value={tags} onChange={e => handleTagInput(e)} beforeAddValidate={e => addValidationTag(e)} />
                                                    </div>
                                                    <small className="text-danger">Após digitar a <span style={{ fontWeight: "bold" }}>Tag</span>, aperte <span style={{ fontWeight: "bold" }}>Enter</span></small>
                                                </div>
                                                <div>
                                                    <button title="Click aqui para incluir uma tag já existente" type="button" className="btn btn-success" style={{ marginTop: "15px" }} onClick={e => handleTagInput(addValidationTag(tag) ? [...tags, tag] : tags)}><i className="fa fa-arrow-left"></i></button>
                                                </div>
                                                <div style={{ width: "300px" }}>
                                                    <div>
                                                        <span>Tags já existentes</span>
                                                        <select className="form-select" value={tag} onChange={e => setTag(e.target.value)} style={{ minHeight: "37px" }}>
                                                            <option value="">Selecione</option>
                                                            {(dataTags || []).map((item) => {
                                                                return (<option value={item}>{item}</option>)
                                                            })}
                                                        </select>
                                                    </div>
                                                    <small className="text-danger">Selecione uma <span style={{ fontWeight: "bold" }}>Tag</span> e click no botão ao lado para inserir</small>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div style={{ display: "flex", gap: "25px", marginTop: "15px" }}>
                                    <div>
                                        <div style={{ display: "flex" }}>
                                            <label className="switch switch-sm" style={{ justifyContent: "center" }}>
                                                <input type="checkbox" checked={rejectcall}
                                                    value={rejectcall}
                                                    onClick={e => setRejectCall(!rejectcall)} />
                                                <span style={{ marginTop: "5px" }}></span>
                                            </label>
                                            <span style={{ marginLeft: "5px", marginTop: "5px" }}>Rejeitar chamadas de voz e video?</span>
                                        </div>
                                        <div className="mb-2" >
                                            <label>Mensagem a ser enviada ao receber uma ligação</label>
                                            <div className="input-group">
                                                <textarea
                                                    name="rejectCall"
                                                    id="rejectCall"
                                                    rows={6}
                                                    disabled={!rejectcall}
                                                    className="form-control"
                                                    onChange={(e) => setMessageReject(e.target.value)}
                                                    value={messagereject}>
                                                </textarea>
                                            </div>
                                        </div>
                                        <div style={{display:"flex", gap:"5px", flexDirection:"column", border:"1px dashed #cacaca", padding:"5px", marginTop:"20px", borderRadius:"5px"}}>
                                            <div style={{marginTop:"-15px"}}>
                                                <span style={{background:"#fff", fontWeight:"bold"}}>Foto do Perfil</span>
                                            </div>
                                            <Dropzone text="Imagem da foto do perfil" onChange={handleFiles}  multiple={false} accept={{ 'image/*': ['.jpg', '.jpeg', '.png','.bmp'] }} />
                                            {selectedFile && (
                                                <div style={{display:"flex", justifyContent:"center"}} title="Remover imagem" onClick={e=> setSelectedFile(null)}>
                                                    <img src={selectedFile.src} alt="" style={{borderRadius:"50%", width:"100px", height:"100px", border:"1px solid #cacaca"}}/>
                                                    <div style={{display:"flex", alignItems:"end", marginTop:"72px",position:"absolute", marginLeft:"65px", padding:"7px", borderRadius:"50%", cursor:"pointer", background:"#fff", border:"1px solid #cacaca"}}>
                                                        <i className='fa fa-trash' style={{color:"#dc3545"}}/>
                                                    </div>
                                                </div>
                                            )}
                                            <button type="button" className='btn btn-success' style={{display:"flex", gap:"5px", alignItems:"center", width:"165px"}} onClick={e => handleUploadFoto(e)}>
                                                <i className='fa fa-image'/>
                                                <span>Alterar foto do perfil</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <label>Cor de destaque do número no atendimento</label>
                                        <SketchPicker
                                            width={240}
                                            color={numbercolor}
                                            onChangeComplete={handleColor}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>  
                    <Button type="submit" id='submit-mynumber-settings' className={`btn-theme ${loading ? "hidden" : ""}`} >  
                        <em className="fa fa-save"></em> Salvar
                    </Button>
                    <Button className="btn-ligth-gray" onClick={handleCloseModal}>
                        <em className="fa fa-door-closed"></em> Fechar
                    </Button>
                </Modal.Footer>
            </ValidationForm> 
        </Modal>
    )
}